// ========================================
// КОНФИГУРАЦИЯ ПРОЕКТА
// ========================================
// Для смены домена измените значения ниже

// Режим работы:
// - 'production' - относительные пути /api (работает по IP и по домену)
// - 'development' - для разработки (localhost)
// - 'custom' - для кастомного домена (укажите BASE_URL)
const APP_MODE = process.env.REACT_APP_MODE || 'production';

// Базовый URL (только для APP_MODE === 'custom')
const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://foodstar.pro';

// ========================================
// Автоматическая конфигурация (не менять)
// ========================================

// Базовый URL для API
export const API_BASE_URL = (() => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL; // Приоритет переменной окружения
  }
  
  switch (APP_MODE) {
    case 'custom':
      return BASE_URL ? `${BASE_URL}/api` : '/api';
    case 'development':
      return 'http://localhost:5000/api';
    case 'production':
    default:
      return '/api'; // Относительный путь
  }
})();

// Базовый URL для сервера (без /api)
export const SERVER_BASE_URL = (() => {
  if (process.env.REACT_APP_SERVER_URL) {
    return process.env.REACT_APP_SERVER_URL; // Приоритет переменной окружения
  }
  
  switch (APP_MODE) {
    case 'custom':
      return BASE_URL || '';
    case 'development':
      return 'http://localhost:5000';
    case 'production':
    default:
      return ''; // Относительные пути
  }
})();

const config = {
  APP_MODE,
  BASE_URL,
  API_BASE_URL,
  SERVER_BASE_URL
};

export default config;
